import { Link } from "react-router-dom";
import { articles } from "@/mocks/data";

export default function PopularArticles() {
  const popular = [...articles].sort((a, b) => b.readCount - a.readCount).slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
              热门文章
            </h2>
            <p className="text-sm text-foreground-600">最受用户关注的9170手机版使用指南与问题解答</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap transition-colors font-medium"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {popular.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-100/60 rounded-lg p-5 hover:bg-background-100 transition-colors duration-200 group border border-background-200/50"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                  {article.tags[0]}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {article.summary}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>{article.publishDate}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.readCount.toLocaleString()}
                </span>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap transition-colors font-medium"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}